import Consultation from "./navigation";
import UTM from './../../util/utm-tracking';

Consultation.prototype.validateUser = function (survey, options) {
    jQuery(".alert").text(""); // hard reset

    // console.log('validateUser');

    if (options.name == "email") {
        if (options.value != this.data.email) {
            // check if email has changed/is not set
            // console.log('email different');
            this.data.email = options.value;
            this.send_data.email = options.value;
            this.user_validated = false;
            survey.setValue("hasExistingAccount", false);
            survey.setValue("isUserLoggedIn", false);
            this.checkUser(this.data, survey);
        } else {
            window.consultation_status = "email_checked";
        }

        if (window.consultation_status == "email_checked") {
            // console.log('email checked');
            window.consultation_status = "idle";
            return;
        }
    }

    if (options.name == "password") {
        if (window.consultation_status == "logged_in") {
            window.consultation_status = "idle";
            return;
        }

        var password_field = document.querySelector("[name=password]");
        var password_container = document.querySelector(".password_container");
        var new_password_field = document.querySelector("[name=new_password]");
        var new_password_container = document.querySelector(
            ".new_password_container"
        );

        if (password_field) {
            // need to log in user
            if (password_field.value) {
                this.loginUser(
                    this.data,
                    password_field.value,
                    survey,
                    options
                );
            } else {
                this.alertDanger();
                options.error = "Please enter a password.";
                return;
            }
        }

        if (new_password_field) {
            // need to create user with entered password
            if (new_password_field.value) {
                if (
                    (window.password_meets_min_reqs(new_password_field.value) ||
                        window.new_password_strength > 2) &&
                    jQuery('input[name="terms_conditions"]:checked').length > 0
                ) {
                    this.createUser(
                        this.data,
                        new_password_field.value,
                        survey
                    );
                } else {
                    // if (this.new_password_strength != 2 &&this.new_password_strength != 3 && this.new_password_strength != 4 && !window.password_min_reqs(new_password_field.value)) {
                    if (
                        !window.password_meets_min_reqs(
                            new_password_field.value
                        ) &&
                        window.new_password_strength <= 2
                    ) {
                        this.alertDanger();
                        options.error =
                            "Please enter a stronger password (6 characters minimum, including letters and numbers)";
                        return;
                    } else {
                        this.alertDanger();
                        options.error =
                            "Please confirm you agree to our Terms & Conditions and Privacy Policy.";
                        return;
                    }
                }
            } else {
                this.alertDanger();
                options.error = "Please enter a password.";
                return;
            }
        }
    }

    if (!this.user_validated) {
        this.alertLoading();
        options.error = "Checking your details...";
    }
};

Consultation.prototype.checkUser = function (data, survey) {
    var that = this;
    data.consultation_nonce = window.consultation_nonce;
    jQuery
        .ajax({
            type: "POST",
            url: "/wp-json/process_consultation/v1/check",
            data: data,
            // beforeSend: function (xhr) {
            //     // Here we set a header 'X-WP-Nonce' with the nonce
            //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
            // },
        })
        .done(function (response) {
            that.hideAlert();

            if (typeof response.user_id != "undefined") {
                that.data.user_id = response.user_id;
                survey.setValue("hasExistingAccount", true);

                // if existing user
                if (!response.logged_in) {
                    survey.setValue("isUserLoggedIn", false);
                } else {
                    that.user_validated = true;
                    survey.setValue("isUserLoggedIn", true);
                }
            }
            // console.log('next page');
            window.consultation_status = "email_checked";
            survey.nextPage();
        })
        .fail(function (xhr, status, error) {
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
            dataLayer.push({
                'event': 'consultation-event',
                'customEventCategory': 'consultation',
                'customEventAction': 'check-user-error',
                'customEventLabel': xhr.responseText,
                'customEventValue': null
            });
        });
};

Consultation.prototype.addPasswordField = function () {
    // console.log('addPasswordField');

    var password_input = document.querySelector(".sv_qstn input");
    var existing_password = document.querySelector("[name='password']");
    if (password_input && existing_password == null) {
        password_input.style.display = "none";
        var input = document.createElement("input");
        input.type = "password";
        input.name = "password";
        var password_container = document.createElement("div");
        password_container.className = "password_container";
        password_container.appendChild(input);
        password_container.innerHTML +=
            "<p><a href='/my-account/lost-password' target='_blank'>Forgot your password?</a></p>";
        password_input.parentNode.insertBefore(
            password_container,
            password_input.nextSibling
        );
    }
};

Consultation.prototype.addNewPasswordField = function () {
    // console.log('addNewPasswordField');

    var that = this;

    var password_input = document.querySelector(".sv_qstn input");
    var existing_password = document.querySelector("[name='new_password']");
    if (password_input && existing_password == null) {
        password_input.style.display = "none";
        var password_container = document.createElement("div");
        password_container.className = "new_password_container";
        password_container.innerHTML +=
            "<div class='password_input'><input type='password' name='new_password' class='new_password' placeholder='Please enter a password' /><span id='password_strength' class='woocommerce-password-strength'></span></div>";
        password_container.innerHTML +=
            "<p><input type='checkbox' class='checkbox--alt' name='terms_conditions' id='terms_conditions' /> <label for='terms_conditions'>I have read and accept the <a href='../../terms-conditions' target='_blank'>Terms & Conditions</a> and <a href='../../privacy-policy' target='_blank'>Privacy Policy</a>.</label></p>";
        password_input.parentNode.insertBefore(
            password_container,
            password_input.nextSibling
        );

        // Binding to trigger checkPasswordStrength
        // https://premium.wpmudev.org/forums/topic/trying-to-add-password-strength-to-signup-form
        jQuery("body").on(
            "keyup",
            "input[name=new_password]",
            function (event) {
                window.checkPasswordStrength(
                    jQuery("input[name=new_password]"),
                    jQuery("#password_strength"),
                    [],
                    false
                );
            }
        );
    }
};
/*
Consultation.prototype.checkPasswordStrength = function ( $pass1, $strengthResult, blacklistArray ) {
    
    // console.log('checkPasswordStrength');

    var pass1 = $pass1.val();
    var pass2 = null;

    // Reset the form & meter
    // $submitButton.attr( 'disabled', 'disabled' );
    $strengthResult.removeClass( 'short bad good strong' );

    // Extend our blacklist array with those from the inputs & site data
    blacklistArray = blacklistArray.concat( wp.passwordStrength.userInputBlacklist() )

    // Get the password strength
    window.new_password_strength = wp.passwordStrength.meter( pass1, blacklistArray, pass2 );

    // Add the strength meter results
    switch ( this.new_password_strength ) {

        case 2:
            $strengthResult.addClass( 'bad' ).html( pwsL10n.bad );
            break;

        case 3:
            $strengthResult.addClass( 'good' ).html( pwsL10n.good );
            break;

        case 4:
            $strengthResult.addClass( 'strong' ).html( pwsL10n.strong );
            break;

        case 5:
            $strengthResult.addClass( 'short' ).html( pwsL10n.mismatch );
            break;

        default:
            $strengthResult.addClass( 'short' ).html( pwsL10n.short );

    }

    return;
}
*/

Consultation.prototype.loginUser = function (data, password, survey, options) {
    var data = {
        email: data.email,
        password: password,
        consultation_nonce: window.consultation_nonce,
    };
    var that = this;

    jQuery
        .ajax({
            type: "POST",
            url: "/wp-json/process_consultation/v1/login",
            data: data,
            // beforeSend: function (xhr) {
            //     // Here we set a header 'X-WP-Nonce' with the nonce
            //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
            // },
        })
        .done(function (response) {
            if (response.status == "success") {
                // console.log('logged-in');
                that.nonce = response.nonce;
                that.user_validated = true;
                window.consultation_status = "logged_in";
                survey.nextPage();
                survey.setValue("hasExistingAccount", true);
                survey.setValue("isUserLoggedIn", true);
                survey.setValue("email", data.email); // email question gets hidden so we need to set the value again
            } else {
                that.alertDanger();
                jQuery(".alert").text("Invalid details");
                var label = 'Invalid details';
                // if (typeof response.message !== 'undefined') {
                //     label = response.message;
                // }
                dataLayer.push({
                    'event': 'consultation-event',
                    'customEventCategory': 'consultation',
                    'customEventAction': 'login-user-error',
                    'customEventLabel': label,
                    'customEventValue': null
                }); 
            }
        })
        .fail(function (xhr, status, error) {
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
            dataLayer.push({
                'event': 'consultation-event',
                'customEventCategory': 'consultation',
                'customEventAction': 'login-user-error',
                'customEventLabel': xhr.responseText,
                'customEventValue': null
            });
        });
};

Consultation.prototype.createUser = function (data, password, survey) {
    var that = this;

    var data = {
        email: data.email,
        password: password,
        name: data.name,
        consultation_nonce: window.consultation_nonce,
    };

    const utm = new UTM();
    const utm_data = utm.getData();
    if (utm_data) {
        data.utm = utm_data;
    }

    jQuery
        .ajax({
            type: "POST",
            url: "/wp-json/process_consultation/v1/create",
            data: data,
            // beforeSend: function (xhr) {
            //     // Here we set a header 'X-WP-Nonce' with the nonce
            //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
            // },
        })
        .done(function (response) {
            if (response.status == "success") {
                that.nonce = response.nonce;
                that.data.user_id = response.user_id;
                that.data.created_at = ~~(Date.now() / 1000);
                that.send_data.created_at = ~~(Date.now() / 1000);
                window.consultation_status = "logged_in";
                survey.nextPage();
                survey.setValue("hasExistingAccount", true);
                survey.setValue("isUserLoggedIn", true);
                survey.setValue("email", data.email); // email question gets hidden so we need to set the value again
                that.user_validated = true;
            }
            else {
                var label = 'Unknown error';
                if (typeof response.message !== 'undefined') {
                    label = response.message;
                }
                dataLayer.push({
                    'event': 'consultation-event',
                    'customEventCategory': 'consultation',
                    'customEventAction': 'create-user-error',
                    'customEventLabel': label,
                    'customEventValue': null
                }); 
            }
        })
        .fail(function (xhr, status, error) {
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
            dataLayer.push({
                'event': 'consultation-event',
                'customEventCategory': 'consultation',
                'customEventAction': 'create-user-error',
                'customEventLabel': xhr.responseText,
                'customEventValue': null
            });
        });
};

Consultation.prototype.checkForDataToSave = function (survey, options) {
    // console.log('checkForDataToSave');

    // save to WP every X fields
    var fieldsGroup = 5;

    if (typeof options != "undefined") {
        var key = options.name,
            value = options.value;

        if (options.name == "name") {
            value = this.ucwords(value);
        }

        this.data[key] = value;
        this.send_data[key] = value;
    }

    var all_questions = survey.getAllQuestions(false);

    var isQuestion; // use to check if key is an actual question or something we've added to data like user_id.

    for (var question in this.data) {
        isQuestion = false;

        if (
            question != "name" &&
            question != "email" &&
            question != "GettingToKnowYouQ15E1" &&
            question != "marketing"
        ) {
            // if question has been removed/hidden, delete value
            if (!survey.data.hasOwnProperty(question)) {
                for (var i = 0; i < all_questions.length; i++) {
                    if (all_questions[i].name == question) {
                        isQuestion = true;
                        break;
                    }
                }

                if (isQuestion) {
                    delete this.data[question];
                    this.send_data[question] = null; // send to remove value from customer.io
                }
            }
        }
    }
    if (Array.isArray(options.value)) {
        var firstSelectedValue = options.value[0];
        if (firstSelectedValue.slice(firstSelectedValue.length - 4) == "Goal") {
            // If we save on this goals question, we might reload on the priority question
            // If we load survey on the 'what's your priority goal' question, it will show all options instead of those they selected in this question
            // So we don't want to save on this question (but we will still save question data later once they have selected priority)
            return;
        }
    }

    if (typeof localStorage != "undefined") {
        // local storage
        localStorage.gp_consultation_type = window.consultation_type;
        localStorage.gp_consultation_data = JSON.stringify(this.data);
        localStorage.gp_consultation_send_data = JSON.stringify(this.send_data);
        localStorage.gp_consultation_page = survey.currentPageNo;

        // cookie
        var date = new Date();
        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toGMTString();
        document.cookie =
            "gp_consultation=" +
            window.consultation_type +
            ";path=/;" +
            expires;
    }

    if (this.data.user_id) {
        if (
            Object.keys(this.send_data).length >= fieldsGroup &&
            !survey.isLastPage
        ) {
            this.data.currentPageNo = survey.currentPageNo;
            this.addData(survey, options);
        }
    }
};

Consultation.prototype.addData = function (survey, options) {
    this.send_data.user_id = this.data.user_id;

    if (jQuery.isEmptyObject(this.sent_data)) {
        if (this.saveError === true) {
            this.saveError = false;
            // they had previously received the "We’re busy processing your answers" message, but have now been able to move through.
            console.log("saveError cleared");
            dataLayer.push({
                event: "consultation-event",
                customEventCategory: "consultation",
                customEventAction: "continued-after-save-error",
                customEventLabel: "Saving error cleared",
                customEventValue: null,
            });
        }
        this.sent_data = this.send_data;
        this.send_data = {};
        var that = this;

        // console.log('saving...');

        // console.log(that.data);

        jQuery
            .ajax({
                type: "POST",
                url: "/wp-json/process_consultation/v1/send",
                data: { data: that.data, send_data: that.sent_data },
                beforeSend: function (xhr) {
                    // Here we set a header 'X-WP-Nonce' with the nonce
                    xhr.setRequestHeader("X-WP-Nonce", that.nonce);
                },
            })
            .done(function (response) {
                if (response.status == "success") {
                    that.data.consultation_id = response.consultation_id;
                    that.sent_data = {};
                } else {
                    options.error = "An error occured. Please refresh the page";
                }
            });
    } else {
        // we are still waiting for last ajax call to finish, pause to stop queries queuing up

        if (this.saveError === true) {
            // save error twice in a row, may indicate bug/issue
            console.log("saveError twice in a row");
            dataLayer.push({
                event: "consultation-event",
                customEventCategory: "consultation",
                customEventAction: "save-error",
                customEventLabel: "Saving error twice in a row",
                customEventValue: null,
            });
        }

        this.saveError = true;
        options.error =
            "We’re busy processing your answers. Please wait a few seconds and submit your answer again";
    }
};

export default Consultation;



// WEBPACK FOOTER //
// ./js/components/consultation/user.js